/** Тип заполнения графика */
export enum CopyType {
    Quarter = 0,
    Month = 1,
    Week = 2,
}

/** Статусы дней */
export enum DateStatusEnum {
    Previous = 'prev',
    Current = 'current',
    Future = 'future',
    Closest = 'closest',
}

/** Содержит палитру классов для окрашивания ячеек календаря */
export enum Palette {
    RedWhite = 'red-white',
    BlueWhite = 'blue-white',
    WhiteBlue = 'white-blue',
    FleshBlack = 'flesh-dark',
    FleshRed = 'flesh-red',
}
export enum ECellClasses {
    isExist = 'exist-date',
    isSelected = 'select-date',
    newDate = 'new-date',
}
/** Формат отчетной даты */
export const CALENDAR_DATES_FORMAT = 'YYYY-MM-DD';
export const CALENDAR_DATES_HUMAN_READABLE_FORMAT = 'DD.MM.YYYY';
